module.exports = __webpack_public_path__ + "media/src/images/icons/flags/indonesia-42ccaa38f4cc5fdbc62658829a2ca300.svg";